export default __webpack_public_path__ + "static/node-js-logo-b6b29e86e448294bb9751985263c4519.svg";